import { ElementRef, EventEmitter, } from '@angular/core';
import { debounce } from 'lodash';
var FormSelectOption = /** @class */ (function () {
    function FormSelectOption() {
    }
    return FormSelectOption;
}());
export { FormSelectOption };
var FormSelectComponent = /** @class */ (function () {
    function FormSelectComponent(eRef) {
        var _this = this;
        this.eRef = eRef;
        this.type = 'text';
        this.disabled = false;
        this.placeholder = '';
        this.error = '';
        this.options = [];
        this._value = '';
        this.changed = new EventEmitter();
        this.dropdownToggle = false;
        this.search = '';
        this.emitChangeEvent = debounce(function (item) {
            return _this.changed.emit(item);
        }, 100);
        this.onChange = function () { };
        this.onTouched = function () { };
    }
    FormSelectComponent.prototype.dropdownToggler = function () {
        var _this = this;
        this.dropdownToggle = !this.dropdownToggle;
        if (this.dropdownToggle) {
            if (this.startAt && this.startAt <= this.dropdownList.nativeElement.children.length - 1) {
                setTimeout(function () {
                    var scrollTop = 0;
                    for (var i = 0; i < _this.startAt; i++) {
                        scrollTop += _this.dropdownList.nativeElement.children[i].offsetHeight;
                    }
                    _this.dropdownList.nativeElement.scrollTo(0, scrollTop);
                }, 100);
            }
            this.search = '';
            this.hiddenElement.nativeElement.focus();
        }
    };
    Object.defineProperty(FormSelectComponent.prototype, "value", {
        get: function () {
            return this._value;
        },
        set: function (val) {
            this._value = val;
            this.onChange(val);
            this.onTouched();
        },
        enumerable: true,
        configurable: true
    });
    FormSelectComponent.prototype.registerOnChange = function (fn) {
        this.onChange = fn;
    };
    FormSelectComponent.prototype.registerOnTouched = function (fn) {
        this.onTouched = fn;
    };
    FormSelectComponent.prototype.writeValue = function (value) {
        if (value) {
            this.value = value;
        }
    };
    FormSelectComponent.prototype.onBlur = function () {
        this.onTouched();
    };
    FormSelectComponent.prototype.onClickOutside = function (event) {
        if (!this.eRef.nativeElement.contains(event.target)) {
            this.dropdownToggle = false;
        }
    };
    FormSelectComponent.prototype.select = function (item, event) {
        if (event) {
            event.preventDefault();
        }
        this.emitChangeEvent(item);
        this.dropdownToggle = false;
        this.value = item.option;
    };
    FormSelectComponent.prototype.getName = function (val) {
        if (!val) {
            return false;
        }
        var filtered = this.options.filter(function (item) { return item.option === val; });
        if (!filtered.length) {
            return false;
        }
        return filtered[0].value;
    };
    return FormSelectComponent;
}());
export { FormSelectComponent };



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/Prod_web-client/src/app/shared/form/inputs/form-select.component.ts.pre-build-optimizer.js